import { useState } from "react";
import "./ResetPassword.css";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // The reset token is taken out of the address bar by public/index.html
  // before any script loads (no analytics on this page) and handed over in
  // memory; captured once, at the first render.
  const [resetToken] = useState(
    () => new URLSearchParams(window.__UB_URL_PARAMS__ || location.search).get("token") || ""
  );

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    if (newPassword !== confirmPassword) {
      setError(t("passwords_do_not_match"));
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}password-reset/confirm/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          reset_token: resetToken,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setMessage(t("password_reset_success"));
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        const errorData = await response.json();
        setError(errorData.detail || t("password_reset_failed"));
      }
    } catch (err) {
      setError(t("password_reset_error"));
    } finally {
      setLoading(false);
    }
  };

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  return (
    <div className="reset-password-form-container">
      <form className="reset-password-form" onSubmit={handleSubmit}>
        <h1>{t("reset_password")}</h1>
        <div className="reset-password-input">
          <input
            id="new-password"
            type="password"
            name="new_password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder={t("new_password")}
            required
            autoComplete="new-password"
          />
        </div>
        <div className="reset-password-input">
          <input
            id="confirm-password"
            type="password"
            name="confirm_password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder={t("confirm_password")}
            required
            autoComplete="new-password"
          />
        </div>
        <div className="submit-area">
          <button className="submit-reset-password" type="submit" disabled={loading}>
            {t("reset_password")}
            {loading && <span className="reset-password-loader"></span>}
          </button>
        </div>
        {message && <div className="reset-password-message">{message}</div>}
        {error && <div className="reset-password-error">{error}</div>}
        <div className="link" onClick={handleLoginRedirect}>
          {t("back_to_login")}
        </div>
      </form>
    </div>
  );
}

export default ResetPassword;
